import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Layout::Cluster as |Item|>\n  <Item>\n    <div class=\'nowrap\'>\n      {{enum/plant-asset-alarm-type @record.alert.alertType}}\n    </div>\n  </Item>\n</Layout::Cluster>")